/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDecisionsForReviewNavigate_decisions_Decision = { readonly __typename: 'Decision', readonly id: string, readonly userSelectedAt: any | null, readonly offerType: _Types.UnderwritingOffer };

export type GetDecisionsForReviewNavigate_Query = { readonly __typename: 'Query', readonly decisions: ReadonlyArray<GetDecisionsForReviewNavigate_decisions_Decision | null> | null };


export type GetDecisionsForReviewNavigateVariables = _Types.Exact<{
  companyId: _Types.Scalars['String']['input'];
}>;


export type GetDecisionsForReviewNavigate = GetDecisionsForReviewNavigate_Query;


export const GetDecisionsForReviewNavigateDocument = gql`
    query GetDecisionsForReviewNavigate($companyId: String!) {
  decisions(companyId: $companyId) {
    id
    userSelectedAt
    offerType
  }
}
    `;

/**
 * __useGetDecisionsForReviewNavigate__
 *
 * To run a query within a React component, call `useGetDecisionsForReviewNavigate` and pass it any options that fit your needs.
 * When your component renders, `useGetDecisionsForReviewNavigate` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecisionsForReviewNavigate({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetDecisionsForReviewNavigate(baseOptions: Apollo.QueryHookOptions<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables> & ({ variables: GetDecisionsForReviewNavigateVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>(GetDecisionsForReviewNavigateDocument, options);
      }
export function useGetDecisionsForReviewNavigateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>(GetDecisionsForReviewNavigateDocument, options);
        }
export function useGetDecisionsForReviewNavigateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>(GetDecisionsForReviewNavigateDocument, options);
        }
export type GetDecisionsForReviewNavigateHookResult = ReturnType<typeof useGetDecisionsForReviewNavigate>;
export type GetDecisionsForReviewNavigateLazyQueryHookResult = ReturnType<typeof useGetDecisionsForReviewNavigateLazyQuery>;
export type GetDecisionsForReviewNavigateSuspenseQueryHookResult = ReturnType<typeof useGetDecisionsForReviewNavigateSuspenseQuery>;
export type GetDecisionsForReviewNavigateQueryResult = Apollo.QueryResult<GetDecisionsForReviewNavigate, GetDecisionsForReviewNavigateVariables>;